import React, { useEffect, useState } from "react";
import ApiServices from "../../services/apiServices";
import "./index.css";

// Faixa verde exibida na HOME com a contagem regressiva para a revisão de
// categorias (RD 91535). Dados vêm da Trava de Categorização vigente.
export default function FaixaRevisaoCategoria() {
  const [trava, setTrava] = useState(null);

  useEffect(() => {
    let ativo = true;
    ApiServices.apiGet("trava-categoria/vigente")
      .then((res) => {
        if (ativo && res && res.data) setTrava(res.data);
      })
      .catch(() => {
        /* sem trava vigente ou erro: a faixa simplesmente não aparece */
      });
    return () => {
      ativo = false;
    };
  }, []);

  if (!trava) return null;

  const dataFim = new Date(trava.dataFimNovaCategorizacao);
  const dataInicio = new Date(trava.dataInicioNovaCategorizacao);
  if (isNaN(dataFim.getTime()) || isNaN(dataInicio.getTime())) return null;

  // Dias entre hoje (00:00 local) e o dia seguinte ao fim (00:00).
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  const revisao = new Date(dataFim);
  revisao.setHours(0, 0, 0, 0);
  revisao.setDate(revisao.getDate() + 1);
  const dias = Math.round((revisao - hoje) / (1000 * 60 * 60 * 24));

  // Trava vencida (job de virada atrasado): não exibe a faixa.
  if (dias <= 0) return null;

  const formatarMes = (data) =>
    new Intl.DateTimeFormat("pt-BR", { month: "long" }).format(data);

  const mesInicio = formatarMes(dataInicio);
  const mesFim = formatarMes(dataFim);
  // Mês da nova categoria = mês do dia seguinte ao fim do período.
  const mesNovaCategoria = formatarMes(revisao);

  return (
    <div className="faixa-revisao-container">
      <div className="faixa-revisao-conteudo">
        <svg
          className="faixa-revisao-icone"
          width="26"
          height="26"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <rect
            x="3"
            y="4.5"
            width="18"
            height="16"
            rx="2.5"
            stroke="#F4D000"
            strokeWidth="2"
          />
          <line x1="3" y1="9" x2="21" y2="9" stroke="#F4D000" strokeWidth="2" />
          <line x1="8" y1="2.5" x2="8" y2="6.5" stroke="#F4D000" strokeWidth="2" strokeLinecap="round" />
          <line x1="16" y1="2.5" x2="16" y2="6.5" stroke="#F4D000" strokeWidth="2" strokeLinecap="round" />
          <rect x="6.5" y="12" width="3" height="3" rx="0.6" fill="#F4D000" />
          <rect x="11" y="12" width="3" height="3" rx="0.6" fill="#F4D000" />
          <rect x="15.5" y="12" width="3" height="3" rx="0.6" fill="#F4D000" />
        </svg>
        <p className="faixa-revisao-texto">
          Faltam <b>{dias} dias</b> para revisão das categorias. Lembrando que as
          compras de {mesInicio} a {mesFim}, garantem a sua nova categoria a
          partir de {mesNovaCategoria}.
        </p>
      </div>
    </div>
  );
}
